module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('hello')], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Buefy Customization Basic Setup")]), _vm._v(" "), _c('b-field', [_c('b-checkbox', [_vm._v("Checkbox")])], 1), _vm._v(" "), _c('b-field', [_c('b-switch', [_vm._v("Default")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "John Silver"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "person"
    }
  }), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "home"
    }
  }), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "dashboard"
    }
  })], 1), _vm._v(" "), _c('b-message', {
    attrs: {
      "title": "Danger with icon",
      "type": "is-danger",
      "has-icon": ""
    }
  }, [_vm._v("\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit\n    ")]), _vm._v(" "), _c('b-field', [_c('b-dropdown', [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Filters")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "arrow_drop_down"
    }
  })], 1), _vm._v(" "), _c('b-option', {
    attrs: {
      "value": "open_issues"
    }
  }, [_vm._v("Open Issues and Pull Requests")]), _vm._v(" "), _c('b-option', {
    attrs: {
      "value": "your_issues"
    }
  }, [_vm._v("Your Issues")]), _vm._v(" "), _c('b-option', {
    attrs: {
      "value": "pull_requests"
    }
  }, [_vm._v("Your Pull Requests")]), _vm._v(" "), _c('b-option', {
    attrs: {
      "value": "everything"
    }
  }, [_vm._v("Everything")])], 1), _vm._v(" "), _c('b-input', {
    attrs: {
      "icon": "search",
      "type": "search",
      "placeholder": "Search..."
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea7d7fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 12
// module chunks = 0